import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import { Card, CardBody, Col, Container, Label, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Select from 'react-select';
import { SOLICITUD_ESTADOS } from "../../ayudas/constantes"

const columns = [
    {
        label: "#",
        field: "id",
        sort: "asc"
    },
    {
        label: "Titulo",
        field: "titulo",
        sort: "asc"
    },
    {
        label: "Fecha solicitud",
        field: "fecha_creacion",
        sort: "asc"
    },
    {
        label: "Fecha programada",
        field: "fecha_programada",
        sort: "asc"
    },
    {
        label: "Ubicación",
        field: "lugar_ubicacion_nombre",
        sort: "asc"
    },
    {
        label: "Estado",
        field: "estado",
        sort: "asc"
    },
    {
        label: "Acciones",
        field: "accion",
        width: 100
    }
];

export default class vistaAsignado extends React.Component {
    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        this.state = {
            tabla: { columns: columns, rows: [] },
            modalAbierto: false,
            mostrarSpinner: true,

            lugar_ubicacion: null,
            tipo_solicitud: null,

            ubicaciones: [],
            tiposSolicitudes: [],
            departamentosAreas: [],

            mostrarTabla: false
        }
        this.buscar = this.buscar.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.cambiosSolicitud = this.cambiosSolicitud.bind(this);
    }

    componentDidMount() {

        //listado de tipo de solicitudes
        this.cargarListado();

        //id del colaborador loggeado especifico
        let usuario = this.apiRest.getLS('du');
        this.buscar(usuario.id);
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            ...estadoAnterior, [name]: value
        }));
    }

    cambiosSolicitud = solicitud => {
        this.setState({ tipo_solicitud: solicitud });
        let usuario = this.apiRest.getLS('du');
        if (solicitud === null) {
            console.log("repintar tabla")
            this.buscar(usuario.id)
        } else {
            console.log("filtrando "+solicitud.value)
            this.filtrar(usuario.id,solicitud.value);
        }
    }

    formatoSelect = valores => valores.data.map(i => ({
        value: i.id, label: i.nombre
    }));

    cargarListado = () => {
        this.setState({ mostrarSpinner: true });

        this.apiRest.get('/tipoSolicitud').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ mostrarSpinner: false, tiposSolicitudes: this.formatoSelect(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    botonesListado = registro => [
        <MDBBtn className="waves-effect"size="sm" color="success" title="Concluir" onClick={() => this.props.history.replace({ pathname: '/solicitud', rol: "tarea_realizado", idRegistro: registro.id })}>
            <MDBIcon icon="fas fa-check" />
        </MDBBtn>
    ];

    estadoValor = registro => {
       return SOLICITUD_ESTADOS[registro.estado].label
    }

    //modificaciones a las celdas de las tablas
    agregarAccionesRegistro = rows => {
        let indice = 1;
        rows.forEach(registro => registro.accion = this.botonesListado(registro));
        rows.forEach(registro => registro.id = (indice++));
        rows.forEach(registro => registro.estado = this.estadoValor(registro));
        return { columns, rows };
    };

    //peticion get retorna una lista de solicitudes asignadas un usuario por medio de su id
    buscar(id) {
        this.setState({ mostrarTabla: true });

        this.apiRest.get('/filtraConsulta/'+id).then(respuesta => {
            if (respuesta.exitoso) {
                respuesta = respuesta.data.map(item => ({ ...item, fecha_creacion: item.fecha_creacion }));
                this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta) });
            }
        });
    }

    //filtra las solicitudes de acuerdo al tipo se debe pasar id colaborador y id tipo de solicitud
    filtrar(idUsuario, idFiltro) {
        this.setState({ mostrarTabla: true });
        if (idUsuario !== null) {
            this.apiRest.get('/filtraTipoSolicitud/'+idFiltro+'/'+idUsuario).then(respuesta => {
                if (respuesta.exitoso) {
                    respuesta = respuesta.data.map(item => ({ ...item, fecha_creacion: item.fecha_creacion }));
                    this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta) });
                }
            });
        }
    }

    render() {
        const {
            mostrarTabla,
            mostrarSpinner,
            tabla,
            tipo_solicitud,
            tiposSolicitudes
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Lista" breadcrumbItem="Mis solicitudes" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col></Col>
                                            <Col lg={3}>
                                                <Label htmlFor="tipo_solicitud" className="form-label">
                                                    Tipo de solicitud
                                                </Label>
                                                <Select
                                                    name="tipo_solicitud"
                                                    options={tiposSolicitudes}
                                                    value={tipo_solicitud}
                                                    onChange={this.cambiosSolicitud}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Selecciona.."
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    noOptionsMessage={() => "No hay más opciones"}
                                                />
                                            </Col>
                                            <Col></Col>
                                        </Row>
                                        <p />
                                        {mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }

                                        {
                                            mostrarTabla && 
                                            <div className="table-responsive">
                                                <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={tabla} />
                                            </div>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}